import { render, staticRenderFns } from "./HandTrack.vue?vue&type=template&id=62bc716a&scoped=true&lang=pug"
import script from "./HandTrack.vue?vue&type=script&lang=js"
export * from "./HandTrack.vue?vue&type=script&lang=js"
import style0 from "./HandTrack.vue?vue&type=style&index=0&id=62bc716a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bc716a",
  null
  
)

export default component.exports